const reducer = (state, action) => {
	switch (action.type) {
		case 'CHANGE VIEW':
			return {
				...state,
				selectedView: action.view ? action.view : state.selectedView,
				mapView: action.mapView ? action.mapView : state.mapView,
				mapFilterProps: action.mapFilterProps ? action.mapFilterProps : state.mapFilterProps,
				mapFilterIndices: action.mapFilterIndices ? action.mapFilterIndices : state.mapFilterIndices,
			};
		case 'CHANGE CITY':
			return {
				...state,
				selectedCity: action.city,
			};
		default:
			return state;
	}
};
export default reducer;
